import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UserAlertsService {
  private jsonUrl = 'https://storage.googleapis.com/user-alerts-configs/companiesConfig.json';

  private headerOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  constructor(private http: HttpClient) {}

  updateAlertMessages(alertData: any): Observable<any> {
    console.log('hereee')
    return this.http.post<any>('/api/alerts/update', alertData, this.headerOptions).pipe(
      catchError(error => {
        console.error('Error occurred while updating alert messages:', error);
        throw error;
      })
    );
  }

  getAlertMessages(): Observable<any> {
    return this.http.get<any>('/api/alerts/get');
  }
  
}
